import * as yup from 'yup'
import { IntlShape } from 'react-intl'

import { IRouteForm } from 'features/Services/components/NewServicesV2/components/RouteCard/types'
import { routeFormSchema } from 'features/Services/components/NewServicesV2/components/RouteCard/schema'

export const schema = (intl: IntlShape): yup.SchemaOf<IRouteForm> => {
  return yup.object().shape({
    ...routeFormSchema(intl, { isCalculatingShape: false }).fields
  })
}
